import { useLocalStorage } from '@uidotdev/usehooks';
import { FeatureFlag } from 'types/features';
import { useIsFeatureEnabled } from 'utils/useFeatureFlags';

import { DEFAULT_INVOICE_TAB_URL_KEY, InvoiceTableTab, TAB_INDEX_TO_URL_KEY } from '../InvoicesTable';

// Resolves which invoice sub-tab URL key to default to when the route has no `:invoiceTab`
// segment. Restores the last-selected tab persisted in localStorage (shared across the global
// list and the contact/matter invoice views), falling back to MAIN — and never resolves to the
// KSEF tab when its feature flag is disabled, since that tab isn't rendered then.
export const useDefaultInvoiceTabKey = (): string => {
    const isKsefTabEnabled = useIsFeatureEnabled(FeatureFlag.KSEF_INVOICES_LIST);
    const [storedTabIndex] = useLocalStorage<number>('invoice-selected-tab', 0);

    const storedKey = TAB_INDEX_TO_URL_KEY[storedTabIndex as InvoiceTableTab] ?? DEFAULT_INVOICE_TAB_URL_KEY;
    return storedKey === 'ksef' && !isKsefTabEnabled ? DEFAULT_INVOICE_TAB_URL_KEY : storedKey;
};
